import { Product, ProductSubscription } from "@core/types";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface ProductSubscriptionState {
  productSubscriptionIdsMap: Record<Product["id"], Product>;
}

interface ProductSubscriptionActions {
  addProductSubscription: (product: Product) => void;
  removeProductSubscription: (product: Product) => void;
}

export const initialCartState: ProductSubscriptionState = {
  productSubscriptionIdsMap: {},
};

export const useProductSubscriptionsStore = create<ProductSubscriptionState & ProductSubscriptionActions>()(
  persist<ProductSubscriptionState & ProductSubscriptionActions>(
    (set, get, api) => {
      return {
        ...initialCartState,

        replaceProductSubscriptions: (productSubscriptions: ProductSubscription[]) => {
          set((state) => ({
            productSubscriptionIdsMap: productSubscriptions.reduce((acc, product) => {
              const productId = product.product_id.id;
              acc[productId] = product.product_id;
              return acc;
            }, {} as Record<Product["id"], Product>),
          }));
        },

        addProductSubscription: (product: Product) => {
          set((state) => ({
            productSubscriptionIdsMap: {
              ...state.productSubscriptionIdsMap,
              [product.id]: product,
            },
          }));
        },

        removeProductSubscription: (product: Product) => {
          set((state) => ({
            productSubscriptionIdsMap: Object.fromEntries(
              Object.entries(state.productSubscriptionIdsMap).filter(([id]) => id !== product.id)
            ),
          }));
        },
      };
    },
    {
      name: "product-subscriptions",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export default useProductSubscriptionsStore;
